var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8943 6.10571C23.7019 9.91332 23.7019 16.0867 19.8943 19.8943C16.0867 23.7019 9.9133 23.7019 6.10571 19.8943C2.2981 16.0867 2.2981 9.9133 6.10571 6.10571C9.91332 2.2981 16.0867 2.2981 19.8943 6.10571",
    stroke: "#5F89F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1549 9.01756C16.345 10.2076 16.345 12.1372 15.1549 13.3273C13.9648 14.5173 12.0353 14.5173 10.8452 13.3273C9.65512 12.1372 9.65512 10.2076 10.8452 9.01756C12.0353 7.82748 13.9648 7.82748 15.1549 9.01756",
    stroke: "#5F89F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1826 20.5378C17.628 18.9009 15.4353 17.875 13 17.875C10.5646 17.875 8.37197 18.9009 6.81738 20.5389",
    stroke: "#5F89F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.4e3d972da91f564f220133ca99d1a5f4.svg";
export { ForwardRef as ReactComponent };